import LoggedInHeader from './LoggedInHeader'

export default LoggedInHeader
